import React from 'react';

import { normalizeCoachObservations, renderCoachObservation } from './coachCopy';
import { WritingAssistContext } from './WritingAssistMoments.types';
import usePrefersReducedMotion from './usePrefersReducedMotion';
import {
  ActionButton,
  ActionRow,
  MomentPanel,
} from './WritingAssistMoments.styles';

export interface CoachInterruptProps {
  context: WritingAssistContext;
  observations: unknown;
  firstCoach?: boolean;
  onPolish: () => void;
  onSaveOriginal: () => void;
}

const CoachInterrupt: React.FC<CoachInterruptProps> = ({
  context,
  observations,
  firstCoach = false,
  onPolish,
  onSaveOriginal,
}) => {
  const normalized = normalizeCoachObservations(context, observations);
  const reducedMotion = usePrefersReducedMotion();
  if (!normalized.length) return null;

  return (
    <MomentPanel
      data-testid="coach-interrupt"
      aria-live="polite"
      style={{ transition: reducedMotion ? 'none' : 'opacity 160ms ease' }}
    >
      <h2>Quick read before this goes out 👀</h2>
      <p>
        {context === 'jobDescription'
          ? "Your words, your call — but here's what candidates might notice:"
          : "Your words, your call — but here's what an office might notice:"}
      </p>
      <ul>
        {normalized.map(observation => (
          <li key={observation.dimension}>{renderCoachObservation(context, observation)}</li>
        ))}
      </ul>
      <ActionRow>
        <ActionButton type="button" data-visual-weight="equal" onClick={onPolish}>
          Show me a polished version
        </ActionButton>
        <ActionButton type="button" data-visual-weight="equal" onClick={onSaveOriginal}>
          Save mine as-is
        </ActionButton>
      </ActionRow>
      {firstCoach ? <p>Polished versions use one of your daily AI polishes.</p> : null}
    </MomentPanel>
  );
};

export default CoachInterrupt;
